import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

import { formatDateTime } from '../../utils/Utils';
import { StatusBadge } from './statusBadge';

// KVKK talebinin ayrıntı GÖVDESİ (kabuk değil): self-servis salt okunur çekmece
// (my-kvkk-requests/KvkkRequestDetailDrawer) ve İK inceleme çekmecesi
// (kvkk-requests/KvkkRequestsPage, GenericFormDrawer çocuğu) aynı alanları aynı biçimde
// gösterir. Açıklama 2000 karaktere kadar çıkabilir; kaydırma kabuğun gövdesindedir.
//
// `variant="hr"`: talep sahibi + işleyen + işlem tarihi de gösterilir (İK yüzü). Self-servis
// görünümünde bunlar yok (çalışan kendi talebine bakıyor; işleyenin adı Görev 9'da
// bilinçli olarak gösterilmedi).
// `showNote={false}`: İK açık kaydı düzenlerken not zaten form alanındadır, ikinci kez yazılmaz.

const MetaGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 12px 16px;
`;

const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

const Label = styled.span`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.text.dark.little};
`;

const Value = styled.span`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text.primary};
  overflow-wrap: anywhere;
`;

const LongText = styled.div`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 14px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.text.primary};
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const dt = (v, lang) => (v ? formatDateTime(v, lang) : '-');

export default function KvkkRequestDetails({ request, variant = 'self', showNote = true }) {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  if (!request) return null;
  const hr = variant === 'hr';

  return (
    <Stack>
      <MetaGrid>
        {hr && (
          <Field>
            <Label>{t('kvkkRequest.employee')}</Label>
            <Value>{request.employeeName || '-'}</Value>
          </Field>
        )}
        <Field>
          <Label>{t('kvkkRequest.type.label')}</Label>
          <Value>{t(`kvkkRequest.type.${request.type}`)}</Value>
        </Field>
        <Field>
          <Label>{t('kvkkRequest.status.label')}</Label>
          <Value>
            <StatusBadge $status={request.status}>{t(`kvkkRequest.status.${request.status}`)}</StatusBadge>
          </Value>
        </Field>
        <Field>
          <Label>{t('kvkkRequest.createdAt')}</Label>
          <Value>{dt(request.createDate, lang)}</Value>
        </Field>
        {hr && (
          <>
            <Field>
              <Label>{t('kvkkRequest.handledBy')}</Label>
              <Value>{request.handledByName || '-'}</Value>
            </Field>
            <Field>
              <Label>{t('kvkkRequest.handledAt')}</Label>
              <Value>{dt(request.handledAt, lang)}</Value>
            </Field>
          </>
        )}
        <Field>
          <Label>{t('kvkkRequest.closedAt')}</Label>
          <Value>{dt(request.closedAt, lang)}</Value>
        </Field>
      </MetaGrid>
      <Field>
        <Label>{t('kvkkRequest.description')}</Label>
        <LongText>{request.description}</LongText>
      </Field>
      {showNote && (
        <Field>
          <Label>{t('kvkkRequest.hrNote')}</Label>
          <LongText>{request.hrNote || '-'}</LongText>
        </Field>
      )}
    </Stack>
  );
}
